import { api } from '../lib/api'

export type SmkStatus = {
  present: boolean
  asciiOnly: boolean
  base64Decodes: boolean
  decodedLen: number
  envVar: string
  fingerprint?: string | null
  hasOldKey: boolean
  oldKeyDecodes: boolean
  canDecryptSample: boolean
  sampleChecked: boolean
  currentKeyVersion?: number | null
  error?: string | null
}

export type SmkRotationPlan = {
  newKeyVersion: number
  kubectlPatchSnippet: string
  notes: string[]
}

export async function getSmkStatus(): Promise<SmkStatus> {
  const { data } = await api.get<SmkStatus>('/api/account/settings/treasury/smk/status')
  return data
}

export async function createSmkRotationPlan(): Promise<SmkRotationPlan> {
  const { data } = await api.post<SmkRotationPlan>('/api/account/settings/treasury/smk/rotate_plan', { ack: true })
  return data
}

export async function verifySmk(): Promise<SmkStatus> {
  const { data } = await api.post<SmkStatus>('/api/account/settings/treasury/smk/verify', {})
  return data
}

export async function rewrapSmk(): Promise<{ processed: number; updated: number; failedIdsCount: number }> {
  const { data } = await api.post<{ processed: number; updated: number; failedIdsCount: number }>(
    '/api/account/settings/treasury/smk/rewrap',
    { ack: true }
  )
  return data
}
